import { layerUrl } from "./metrics";
import type { DashboardConfig } from "./types";

export interface RefreshableLayerLike {
  url?: string | null;
  refreshInterval: number;
}

function normalizedUrl(url: string): string {
  return url.replace(/\/$/, "").toLowerCase();
}

export function configureLiveLayerRefresh(
  layers: Iterable<RefreshableLayerLike>,
  config: DashboardConfig
): number {
  const liveLayerUrls = new Set([
    normalizedUrl(config.services.vesselPositionsUrl),
    normalizedUrl(layerUrl(config.services.portInfrastructureUrl, 2))
  ]);
  const refreshMinutes = Math.max(config.refreshSeconds, 30) / 60;
  let configured = 0;

  for (const layer of layers) {
    if (typeof layer.url !== "string" || !liveLayerUrls.has(normalizedUrl(layer.url))) {
      continue;
    }
    layer.refreshInterval = refreshMinutes;
    configured += 1;
  }

  return configured;
}
